<div>
  <img
    id="six-arts-logo"
    class="top-padding"
    src="assets/images/six_arts_logo_long.png"
    routerLink="/six-arts"
  />

  <div style="text-align: left;">
    <p id="back-link">
      <a routerLink="/six-arts">返回</a>
    </p>
  </div>
</div>

<hr />

<div *ngIf="course">
  <h2 id="courseTitle">{{ course.name }}</h2>
  <div class="row">
    <div class="col-md-6">
      <table [style.background-color]="[course.color]" class="table">
        <tbody>
          <ng-container *ngFor="let heading of course['column_en']; index as i;">
            <tr *ngIf="course[heading]">
              <th class="detailTable tableLabels" *ngIf="heading != 'id'">
                {{ course.column_names[i] }}
              </th>
              <td
                class="detailTable"
                *ngIf="heading != 'id'"
                [innerHTML]="course[heading]"
              ></td>
            </tr>
          </ng-container>
          <tr>
            <th class="detailTable">地點</th>
            <td class="detailTable">
              六藝學坊 <br />
              北角英皇道60號康福園1樓A室 <br />
              港鐵 - 炮台山站A出口 <br />
              電車 - 英皇道木星街站 <br />
              巴士 - 英皇道七海商業中心站 <br />
            </td>
          </tr>
          <tr>
            <th class="detailTable">報名</th>
            <td class="detailTable">
              親臨或致電本中心 (2111-0835) 報名參加 <br />
              WHATSAPP : 5574-5771 <br />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-6">
      <img
        *ngIf="course.imageUrl"
        [src]="course.imageUrl"
        class="courseImage rounded"
      />
    </div>
  </div>
</div>

<p *ngIf="!course">尋找中 ...</p>
